/**
 * Split answer text into plain-text and citation segments by matching exact
 * `[ID:<id>]` markers against the known set of reference ids. Pure +
 * framework-free so it is unit-testable without React.
 */

export type CitationSegment =
  | { kind: "text"; text: string }
  | { kind: "cite"; id: string };

const escapeRegExp = (s: string): string =>
  s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

export const segmentCitations = (
  text: string,
  ids: string[],
): CitationSegment[] => {
  const known = new Set(ids.filter((k) => k.length > 0));
  if (known.size === 0) return [{ kind: "text", text }];

  const alternation = [...known]
    .sort((a, b) => b.length - a.length)
    .map(escapeRegExp)
    .join("|");
  const re = new RegExp(`\\[ID:(${alternation})\\]`, "g");

  const segments: CitationSegment[] = [];
  let last = 0;
  let m: RegExpExecArray | null;
  while ((m = re.exec(text)) !== null) {
    if (m.index > last) {
      segments.push({ kind: "text", text: text.slice(last, m.index) });
    }
    segments.push({ kind: "cite", id: m[1] });
    last = m.index + m[0].length;
  }
  if (last < text.length) {
    segments.push({ kind: "text", text: text.slice(last) });
  }
  return segments.length === 0 ? [{ kind: "text", text }] : segments;
};
